export const LOG_PREFIX = '[Selectives Bookmarking]',
  LOCAL_STORAGE_KEY = 'Bookmarking',
  LOCAL_STORAGE_KEY_EXPIRES = 'Bookmarking-local-expiration',
  LOGIN_URL = `/login`,
  STATUS_ATTRIBUTE = 'data-status',
  BUTTON_STATE_ATTRIBUTE = 'data-button-state',
  PLATFORM_LIST_DIV = '.selectives-bookmark-list',
  PLATFORM_BUTTON_DIV = '.selectives-bookmark-button';

export const elements = {
  allBookmarkButtons: document.querySelectorAll(PLATFORM_BUTTON_DIV),
  outerListContainer: document.querySelector(PLATFORM_LIST_DIV),
};

export enum Actions {
  UPDATE_STORE = 'bookmarking::updateStore',
}

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
export const BUILD_TIMESTAMP = __TIMESTAMP__;
